import { Autocomplete, TextField } from "@mui/material";
import EncampAutocomplete from "components/Forms/EncampAutocomplete";

import { SEARCH_TENANTS_QUERY } from "../queries";
import { StateOption, TenantOption } from "../types";

interface TenantForStateRuleFieldsProps {
  selectedTenant: TenantOption | null;
  tenantSearchVariables: {
    search: string;
    pageSize: number;
    sort: { field: string; sort: "asc" | "desc" }[];
  };
  tenantForStateValue: string;
  stateOptions: StateOption[];
  onTenantChange: (tenant: TenantOption | null) => void;
  onTenantInputChange: (value: string) => void;
  onStateChange: (stateValue: string) => void;
}

/**
 * Field component for tenant-for-state rules (Deny Tenant for State)
 * Combines tenant selection with state selection
 */
export function TenantForStateRuleFields({
  selectedTenant,
  tenantSearchVariables,
  tenantForStateValue,
  stateOptions,
  onTenantChange,
  onTenantInputChange,
  onStateChange,
}: TenantForStateRuleFieldsProps) {
  return (
    <>
      <EncampAutocomplete
        query={SEARCH_TENANTS_QUERY}
        getItems={(data) => data?.tenants.items ?? []}
        getOptionLabel={(option) => option.name}
        variables={tenantSearchVariables}
        value={selectedTenant}
        onChange={onTenantChange}
        onInputChange={onTenantInputChange}
        label="Organization"
        hideErrors
      />
      <Autocomplete
        options={stateOptions}
        value={
          tenantForStateValue
            ? stateOptions.find((opt) => opt.value === tenantForStateValue) || null
            : null
        }
        onChange={(_, newValue) => {
          const newStateValue =
            newValue && typeof newValue === "object" && "value" in newValue ? newValue.value : "";
          onStateChange(newStateValue);
        }}
        getOptionLabel={(option) => {
          if (typeof option === "object" && "label" in option) {
            return option.label;
          }
          return "";
        }}
        renderInput={(params) => (
          <TextField {...params} label="State" placeholder="Select state for denial" />
        )}
      />
    </>
  );
}
